var render = function render(_c,_vm){return _c('svg',_vm._g(_vm._b({class:[_vm.data.class, _vm.data.staticClass],attrs:{"viewBox":_vm.$options.iconViewBox(_vm.props.icon, _vm.props.viewBox)}},'svg',_vm.data.attrs,false),_vm.listeners),_vm._l((_vm.$options.iconPaths(_vm.props.icon)),function(path,index){return _c('path',{key:index,attrs:{"id":path.id,"d":path.d,"fill":path.fill,"transform":path.transform}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }